
import apiMonolito from './apiMonolito';
import LZString from 'lz-string';

let utils = require('@/utils')
var dateFormat = require("dateformat")

// Helper para descompresión segura
function safeDecompress(response) {
    if (!response || !response.data) return null;

    // Si ya es un objeto/array, devolverlo directamente
    if (typeof response.data === 'object') {
        return response.data;
    }

    try {
        // Intentar descomprimir
        const decoded = LZString.decompressFromBase64(response.data);
        if (decoded) {
            return JSON.parse(decoded);
        }
        // Si falla la descompresión (retorna null), quizás era texto plano o JSON stringify
        return JSON.parse(response.data);
    } catch (e) {
        console.warn("Fallo descompresión/parseo en get.js:", e);
        return null;
    }
}

export async function get_appointments(seleccionado, nombres, profesional) {
    let idProfesional;
    let indice;

    if (seleccionado != null) {
        indice = nombres.findIndex(profesional => profesional.value === seleccionado.value);
        idProfesional = profesional[indice].id;
    } else {
        idProfesional = 0;
    }

    try {
        const response = await apiMonolito.get(`/events/${idProfesional}`);
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo citas:', error);
        throw error;
    }
}

export async function get_appointments_dr(profesional, historial = false) {
    let idProfesional = profesional;
    let url = historial ? `/appointmentsdr-historial/${idProfesional}` : `/appointmentsdr/${idProfesional}`;

    try {
        const response = await apiMonolito.get(url);
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo citas del doctor:', error);
        return 404;
    }
}

export async function get_appointments_auth(idProfesional) {
    try {
        const response = await apiMonolito.get(`/events/${idProfesional}`);
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo citas autenticadas:', error);
        return 404;
    }
}

export function decode_eventos(initial_data) {
    if (!Array.isArray(initial_data)) return { "citas": [], "pacientes": [] };

    let pacientes = []
    let jsonLocale = []

    for (let x of initial_data) {
        if (x.appointment_date) {
            let fechaUTC = utils.convertUTCDateToLocalDate(x.appointment_date)
            let fechaEnd = utils.convertUTCDateToLocalDate(x.appointment_date_end)
            fechaUTC = dateFormat(fechaUTC, "yyyy-mm-dd HH:MM:ss");
            fechaEnd = dateFormat(fechaEnd, "yyyy-mm-dd HH:MM:ss");
            x.appointment_date = fechaUTC
            x.appointment_date_end = fechaEnd
            jsonLocale.push(x)
        } else {
            pacientes.push(x)
        }
    }

    let datos = jsonLocale
    pacientes = JSON.parse(JSON.stringify(pacientes).split('"name":').join('"nombre":'));
    let data = []

    for (let i = 0; i < datos.length; i++) {
        data.push(Object.assign(datos[i], pacientes[i]))
    }

    let json = JSON.parse(JSON.stringify(data).split('"appointment_date":').join('"start":'));
    json = JSON.parse(JSON.stringify(json).split('"appointment_date_end":').join('"end":'));
    json = JSON.parse(JSON.stringify(json).split('"name":').join('"title":'));
    json = JSON.parse(JSON.stringify(json).split('"id":').join('"id":'));

    return { "citas": json, "pacientes": pacientes }
}

export async function get_profesional() {
    try {
        const response = await apiMonolito.get('/profesional');
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo profesionales:', error);
        return 404;
    }
}

export function decode_profesional(data) {
    if (!Array.isArray(data)) return [];

    let newJson = []
    let especialidad
    for (let item in data) {
        if (data[item].specialty == null) {
            especialidad = ""
        } else {
            especialidad = data[item].specialty.name
        }

        newJson.push({
            value: data[item].party.name + " " + data[item].party.lastname + " - " + utils.traducir(especialidad),
            id: data[item].id,
            text: data[item].party.name + " " + data[item].party.lastname + " - " + utils.traducir(especialidad)
        })
    }
    return newJson
}

export async function get_initial_data() {
    try {
        const response = await apiMonolito.get('/data');
        return safeDecompress(response) || [];
    } catch (error) {
        console.warn('Error obteniendo datos iniciales, returning empty array:', error.message);
        return [];
    }
}

export async function get_historia_clinica(paciente) {
    try {
        const response = await apiMonolito.get(`/historia-clinica/${paciente}`);
        return safeDecompress(response) || [];
    } catch (error) {
        console.warn('Error obteniendo historia clínica, returning empty array:', error.message);
        return [];
    }
}

export async function get_indicadores() {
    try {
        const response = await apiMonolito.get('/indicadores');
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo indicadores:', error);
        return 404;
    }
}

export async function get_medicamentos() {
    try {
        const response = await apiMonolito.get('/medicamentos');
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo medicamentos:', error);
        return 404;
    }
}

export async function get_paciente_data(patient, dni) {
    let url = !patient ? `/persona/${dni}` : `/person/${dni}`;

    try {
        const response = await apiMonolito.get(url);
        return safeDecompress(response) || 404;
    } catch (error) {
        console.error('Error obteniendo datos del paciente:', error);
        return 404;
    }
}

export async function get_paciente(patient_id) {
    try {
        const response = await apiMonolito.get(`/paciente-detail/${patient_id}`);
        return safeDecompress(response) || 404;
    } catch (error) {
        console.error('Error obteniendo paciente:', error);
        return 404;
    }
}

export async function get_appointments_paciente(paciente = null) {
    // Si paciente es null o undefined, no hacer la llamada
    if (!paciente) {
        console.warn('get_appointments_paciente: paciente es null o undefined');
        return [];
    }

    let url = `/turnospaciente/${paciente}`;

    try {
        const response = await apiMonolito.get(url);
        return safeDecompress(response) || [];
    } catch (error) {
        console.error('Error obteniendo citas del paciente:', error);
        return [];
    }
}